export interface UserRole {
  id: string;
  name: string;
  description: string;
  selected: boolean;
}
